export default "__VITE_ASSET__45721fd7__"